<script lang="ts" setup>
  import { computed } from 'vue';
  import { useUnitFormatter, type Unit } from '@othercommerce/domain';

  type Format = 'short' | 'long' | 'genitive' | 'accusative';

  interface Props {
    unit: Unit,
    quantity: string | number,
    format?: Format | null | undefined,
  }

  const props = withDefaults(defineProps<Props>(), {
    format: 'short',
  });

  const unitFormatter = useUnitFormatter();

  const formatted = computed(() => {
    let unit = props.unit;
    let quantity = props.quantity;

    if (unit && quantity) {
      switch (props.format) {
        case 'short':
          return unitFormatter.short(unit, quantity);
        case 'long':
          return unitFormatter.long(unit, quantity);
        case 'genitive':
          return unitFormatter.genitive(unit, quantity);
        case 'accusative':
          return unitFormatter.accusative(unit, quantity);
      }
    }

    return undefined;
  });
</script>
<template>
  <span class="unit" v-html="formatted" />
</template>
